"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Transform = void 0;
var Transform;
(function (Transform) {
    Transform["Sentence"] = "u-sentence";
    Transform["Uppercase"] = "u-uppercase";
    Transform["Lowercase"] = "u-lowercase";
    Transform["Capitalize"] = "u-capitalize";
})(Transform = exports.Transform || (exports.Transform = {}));
//# sourceMappingURL=Transform.js.map